import { render, staticRenderFns } from "./my-workflow.vue?vue&type=template&id=c5294b46"
import script from "./my-workflow.vue?vue&type=script&lang=js"
export * from "./my-workflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports